import React, { useEffect,useState } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css'; // Ensure the correct path to your CSS
import '../../plugins/morris/morris.css';
import axios from 'axios';
import AdminSidebar from '../Adminsidebar/AdminSidebar';
import logo from "../../../assets/img/logo.png"



function Dashboard() {
  useEffect(() => {
      if (window.$) {
            window.$('.datatable').DataTable();
              window.Morris.Area({
                element: 'morrisArea',
                lineColors: ['#009efb', '#6d5dd3', '#e0e0e0'],
                data: [{ y: '2016', a: 100, b: 70, c: 40 },
                    { y: '2017', a: 75, b: 60, c: 35 },
                    { y: '2018', a: 50, b: 80, c: 50 },
                    { y: '2019', a: 75, b: 60, c: 70 },
                    { y: '2020', a: 100, b: 70, c: 50 }
                ],
                xkey: 'y',
                ykeys: ['a', 'b', 'c'],
                labels: ['Doctors', 'Patients', 'Appointmennt'],
                pointSize: 0,
                fillOpacity: 0.8,
                lineWidth: 0,
                parseTime: false,
                resize: true,
                behaveLikeLine: true
            });

            window.Morris.Line({
                element: 'morrisLine',
                 lineColors: ['#009efb', '#6d5dd3'],
                data: [{ y: '2016', a: 40, b: 40 },
                    { y: '2017', a: 70, b: 60 },
                    { y: '2018', a: 40, b: 80 },
                    { y: '2019', a: 60, b: 60 },
                    { y: '2020', a: 40, b: 40 }
                ],
                 xkey: 'y',
                ykeys: ['a', 'b'],
                labels: ['Doctors', 'Appointmennt'],
                lineWidth: 0,
				fillOpacity: 0.6,
				pointSize: 0,
                grid: false,
                resize: true,
				parseTime: false,
				behaveLikeLine: true
            });
        }
    }, []);
    const [dashboardData, setDashboardData] = useState({
      doctors: [],
      appointment: [],
      patients: [],
      checkouts: [],
      blogs: [],
  });
  const [isOpen, setIsOpen] = useState(false);


  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const [doctorPatientData, setDoctorPatientData] = useState([]);
  const [todaysAppointments, setTodaysAppointments] = useState([]);
  const [todaysPatients, setTodaysPatients] = useState([]);
  const [todaysDoctors, setTodaysDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const backendUrl = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL;

    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; 


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
        try {
             const [
                  doctorsRes,
                  appointmentRes,
                  patientsRes,
                  checkoutsRes,
                  blogsRes,
              ] = await Promise.all([
                  axios.get(`${backendUrl}/api/doctor`),
                  axios.get(`${backendUrl}/booking`),
                  axios.get(`${backendUrl}/patients`),
                   axios.get(`${backendUrl}/checkout`),
                  axios.get(`${backendUrl}/api/blogs`),
              ]);

              const doctors = doctorsRes.data;
              const bookings = appointmentRes.data;
              const patients = patientsRes.data;
              const checkouts = checkoutsRes.data;
               const blogs = blogsRes.data;

              // Set data based on the fetched data
              setDashboardData({
                  doctors,
                  bookings,
                  patients,
                  checkouts,
                   blogs,
              });

          // Prepare data for the combined doctor/patient line chart
           const doctorCounts = {};
           doctors.forEach(doctor => {
             const year = new Date().getFullYear();
               doctorCounts[year] = (doctorCounts[year] || 0) + 1;

           });


          const patientCounts = {};
           patients.forEach(patient => {
               if (patient.lastVisit) {
                const year = new Date(patient.lastVisit).getFullYear();
                patientCounts[year] = (patientCounts[year] || 0) + 1;
               } else{
                    const year = new Date().getFullYear();
                     patientCounts[year] = (patientCounts[year] || 0) + 1;
               }
         });

        const allYears = Array.from({ length: 11 }, (_, i) => 2015 + i);

         const chartData = allYears.map(year => ({
           year: year,
           doctors: doctorCounts[year] || 0,
           patients: patientCounts[year] || 0,
        }));

        setDoctorPatientData(chartData);

          // Filter appointments for today
          const today = new Date();
          const todaysBookings = bookings.filter(booking => {
            const bookingDate = new Date(booking.createdAt);
            return (
              bookingDate.getDate() === today.getDate() &&
              bookingDate.getMonth() === today.getMonth() &&
              bookingDate.getFullYear() === today.getFullYear()
            );
          });
          setTodaysAppointments(todaysBookings);

          // Filter patients for today
         const todayPatients = patients.filter(patient => {
            if(patient.lastVisit){
            const patientVisitDate = new Date(patient.lastVisit);
            return (
                 patientVisitDate.getDate() === today.getDate() &&
                  patientVisitDate.getMonth() === today.getMonth() &&
                  patientVisitDate.getFullYear() === today.getFullYear()
            );
           }else {
              const patientDate = new Date();
             return (
                 patientDate.getDate() === today.getDate() &&
                  patientDate.getMonth() === today.getMonth() &&
                  patientDate.getFullYear() === today.getFullYear()
            );

           }

          });
            setTodaysPatients(todayPatients);


          // Filter doctors
          const todayDoctors = doctors.filter(doctor => {
             const doctorDate = new Date();
             return (
              doctorDate.getDate() === today.getDate() &&
              doctorDate.getMonth() === today.getMonth() &&
              doctorDate.getFullYear() === today.getFullYear()
            );

         })
          setTodaysDoctors(todayDoctors);


     } catch (err) {
         setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

 const [activeLink, setActiveLink] = useState(null);

    const handleLinkClick = (link) => {
        setActiveLink(link);
    };

  const formatTime = (date) => {
    const d = new Date(date);
    const formattedTime = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    const formattedDate = d.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    return `${formattedDate} ${formattedTime}`;
  };

 if (loading) return <p>Loading dashboard data...</p>;
 if (error) return <p>Error: {error}</p>;
  return (
    <>
    <div className="main-wrapper">
    <div className="hitkari-main-wrapper">
    

      <AdminSidebar/>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Welcome Admin!</h3>
             
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <span className="dash-widget-icon text-primary border-primary">
                      <i className="fe fe-users"></i>
                    </span>
                    <div className="dash-count">
                      <h3>{dashboardData.doctors.length}</h3>
                    </div>
                  </div>
                  <div className="dash-widget-info">
                    <h6 className="text-muted">Doctors</h6>
                    <div className="progress progress-sm">
                      <div className="progress-bar bg-primary w-50"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <span className="dash-widget-icon text-success">
                      <i className="fe fe-credit-card"></i>
                    </span>
                    <div className="dash-count">
                      <h3>{dashboardData.patients.length}</h3>
                    </div>
                  </div>
                  <div className="dash-widget-info">
                    <h6 className="text-muted">Patients</h6>
                    <div className="progress progress-sm">
                      <div className="progress-bar bg-success w-50"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <span className="dash-widget-icon text-danger border-danger">
                      <i className="fe fe-money"></i>
                    </span>
                    <div className="dash-count">
                      <h3>{dashboardData.bookings.length}</h3>
                    </div>
                  </div>
                  <div className="dash-widget-info">
                    <h6 className="text-muted">Appointment</h6>
                    <div className="progress progress-sm">
                      <div className="progress-bar bg-danger w-50"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <span className="dash-widget-icon text-warning border-warning">
                      <i className="fe fe-folder"></i>
                    </span>
                    <div className="dash-count">
                      <h3>{dashboardData.blogs.length}</h3>
                    </div>
                  </div>
                  <div className="dash-widget-info">
                    <h6 className="text-muted">Blogs</h6>
                    <div className="progress progress-sm">
                      <div className="progress-bar bg-warning w-50"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-md-12 col-lg-6">
              <div className="card card-chart">
                <div className="card-header">
                  <h4 className="card-title">Revenue</h4>
                </div>
                <div className="card-body">
                  <div id="morrisArea"></div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <div className="card card-chart">
                <div className="card-header">
                  <h4 className="card-title">Status</h4>
                </div>
                <div className="card-body">
                  <div id="morrisLine"></div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card card-table flex-fill">
                <div className="card-header">
                  <h4 className="card-title">Doctors List</h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover table-center mb-0">
                      <thead>
                        <tr>
                          <th>Doctor Name</th>
                          <th>Speciality</th>
                          <th>Earned</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                      {todaysDoctors.map((doctor) => (
                        <tr key={doctor._id}>
                          <td>
                            <h2 className="table-avatar">
                              <div className="avatar avatar-sm mr-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src={`${API_BASE_URL}/doctor/${doctor.image}`}
                                  alt="User Image"
                                />
                              </div>
                              {doctor.name}
                            </h2>
                          </td>
                          <td>{doctor.speciality}</td>
                          <td>₹{doctor.price}.00</td>
                         
                        </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="card  card-table flex-fill">
                <div className="card-header">
                  <h4 className="card-title">Patients List</h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover table-center mb-0">
                      <thead>
                        <tr>
                          <th>Patient Name</th>
                          <th>Phone</th>
                          <th>age</th>
                          <th>Email</th>
                          <th>Address</th>
                        </tr>
                      </thead>
                      <tbody>
                      {todaysPatients.map((patient) => (
                  <tr key={patient.patientId}>
                          <td>
                            <h2 className="table-avatar">
                              
                              {patient.firstName} {patient.lastName}
                            </h2>
                          </td>
                          <td>{patient.phone}</td>
                          <td>{patient.age}</td>
                          <td>{patient.email}</td>
                          <td className="">{patient.address}</td>
                        </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    </div>
    </>
  );
}

export default Dashboard;